<af-main-container #mainContainer
                   [title]="'i18n_af_labelIncidentTransactionIndex' | translate :{index: transactionId || '№'+(transactionIndex + 1)}"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [filterNavigationPath]="Path.TRANSACTIONS"
                   [specialFilter]="filter"
                   [customNavigateToPath]="customNavigateToPath"
                   [queryParamsHandling]="'merge'"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">
    <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <ui-kit-button type="secondary"
                       spinnerId="saveEdit"
                       [label]="'i18n_af_buttonCancel' | translate"
                       (clickListener)="mainContainer.breadcrumbs.navigateBack()"/>
        <ui-kit-button spinnerId="saveEdit"
                       [label]="'i18n_af_buttonSave' | translate"
                       (clickListener)="save()"/>
    </div>
    @if (transactions?.length) {
        <af-transaction-information-step class="w-100 mt-24 overflow-y-scroll"
                                         [mode]="'edit'"
                                         [form]="form"
                                         [indexStartsFrom]="transactionIndex"
                                         [transactions]="transactions"/>
    } @else if (!transactionId) {
        <af-transaction-information-step class="w-100 mt-24 overflow-y-scroll"
                                         [mode]="'create'"
                                         [form]="form"
                                         [indexStartsFrom]="transactionIndex"
                                         [transactions]="transactions"/>
    }
</af-main-container>
